// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file live178/v1/identity.proto (package live178.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { OperationResult, PageRequest, PageResponse } from "./common_pb";
import { file_live178_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file live178/v1/identity.proto.
 */
export const file_live178_v1_identity: GenFile = /*@__PURE__*/
  fileDesc("ChlsaXZlMTc4L3YxL2lkZW50aXR5LnByb3RvEgpsaXZlMTc4LnYxIpsCCgtVc2VyUHJvZmlsZRIPCgd1c2VyX2lkGAEgASgJEhQKDHBob25lX21hc2tlZBgCIAEoCRIQCghuaWNrbmFtZRgDIAEoCRISCgphdmF0YXJfdXJsGAQgASgJEiYKBnN0YXR1cxgFIAEoDjIWLmxpdmUxNzgudjEuVXNlclN0YXR1cxIpCgpreWNfc3RhdHVzGAYgASgOMhUubGl2ZTE3OC52MS5LeWNTdGF0dXMSEQoJdGVlbl9tb2RlGAcgASgIEi4KCmNyZWF0ZWRfYXQYCCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEikKCnVzZXJfbGV2ZWwYCSABKA4yFS5saXZlMTc4LnYxLlVzZXJMZXZlbCLoAQoNRGV2aWNlU2Vzc2lvbhISCgpzZXNzaW9uX2lkGAEgASgJEhEKCWRldmljZV9pZBgCIAEoCRIQCghwbGF0Zm9ybRgDIAEoCRITCgtkZXZpY2VfbmFtZRgEIAEoCRIWCg5sYXN0X2lwX21hc2tlZBgFIAEoCRIwCgxsYXN0X3NlZW5fYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCmV4cGlyZXNfYXQYByABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEg8KB2N1cnJlbnQYCCABKAgiYgoRUmVxdWVzdE90cFJlcXVlc3QSEgoKcGhvbmVfZTE2NBgBIAEoCRIPCgdwdXJwb3NlGAIgASgJEhUKDWNhcHRjaGFfdG9rZW4YAyABKAkSEQoJZGV2aWNlX2lkGAQgASgJIooBChJSZXF1ZXN0T3RwUmVzcG9uc2USFAoMY2hhbGxlbmdlX2lkGAEgASgJEhsKE3JldHJ5X2FmdGVyX3NlY29uZHMYAiABKAUSLgoKZXhwaXJlc19hdBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEQoJZGVidWdfb3RwGAQgASgJIm8KEFZlcmlmeU90cFJlcXVlc3QSFAoMY2hhbGxlbmdlX2lkGAEgASgJEgsKA290cBgCIAEoCRIRCglkZXZpY2VfaWQYAyABKAkSEwoLZGV2aWNlX25hbWUYBCABKAkSEAoIcGxhdGZvcm0YBSABKAkioQEKEVZlcmlmeU90cFJlc3BvbnNlEhQKDGFjY2Vzc190b2tlbhgBIAEoCRIVCg1yZWZyZXNoX3Rva2VuGAIgASgJEjUKEWFjY2Vzc19leHBpcmVzX2F0GAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIoCgdwcm9maWxlGAQgASgLMhcubGl2ZTE3OC52MS5Vc2VyUHJvZmlsZSLtAQoPUmVnaXN0ZXJSZXF1ZXN0EhQKDGNoYWxsZW5nZV9pZBgBIAEoCRILCgNvdHAYAiABKAkSEAoIcGFzc3dvcmQYAyABKAkSEAoIbmlja25hbWUYBCABKAkSEQoJZGV2aWNlX2lkGAUgASgJEhMKC2RldmljZV9uYW1lGAYgASgJEhAKCHBsYXRmb3JtGAcgASgJEh4KFnRlcm1zX2RvY3VtZW50X3ZlcnNpb24YCCABKAkSIAoYcHJpdmFjeV9kb2N1bWVudF92ZXJzaW9uGAkgASgJEhcKD2NvbnNlbnRfZ3JhbnRlZBgKIAEoCCKgAQoQUmVnaXN0ZXJSZXNwb25zZRIUCgxhY2Nlc3NfdG9rZW4YASABKAkSFQoNcmVmcmVzaF90b2tlbhgCIAEoCRI1ChFhY2Nlc3NfZXhwaXJlc19hdBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASKAoHcHJvZmlsZRgEIAEoCzIXLmxpdmUxNzgudjEuVXNlclByb2ZpbGUicwoUUGFzc3dvcmRMb2dpblJlcXVlc3QSDwoHYWNjb3VudBgBIAEoCRIQCghwYXNzd29yZBgCIAEoCRIRCglkZXZpY2VfaWQYAyABKAkSEwoLZGV2aWNlX25hbWUYBCABKAkSEAoIcGxhdGZvcm0YBSABKAkipQEKFVBhc3N3b3JkTG9naW5SZXNwb25zZRIUCgxhY2Nlc3NfdG9rZW4YASABKAkSFQoNcmVmcmVzaF90b2tlbhgCIAEoCRI1ChFhY2Nlc3NfZXhwaXJlc19hdBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASKAoHcHJvZmlsZRgEIAEoCzIXLmxpdmUxNzgudjEuVXNlclByb2ZpbGUiQQoVUmVmcmVzaFNlc3Npb25SZXF1ZXN0EhUKDXJlZnJlc2hfdG9rZW4YASABKAkSEQoJZGV2aWNlX2lkGAIgASgJInwKFlJlZnJlc2hTZXNzaW9uUmVzcG9uc2USFAoMYWNjZXNzX3Rva2VuGAEgASgJEhUKDXJlZnJlc2hfdG9rZW4YAiABKAkSNQoRYWNjZXNzX2V4cGlyZXNfYXQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIjgKDUxvZ291dFJlcXVlc3QSEgoKc2Vzc2lvbl9pZBgBIAEoCRITCgthbGxfZGV2aWNlcxgCIAEoCCIqCg5Mb2dvdXRSZXNwb25zZRIYChByZXZva2VkX3Nlc3Npb25zGAEgASgFIhMKEUdldFByb2ZpbGVSZXF1ZXN0Ij4KEkdldFByb2ZpbGVSZXNwb25zZRIoCgdwcm9maWxlGAEgASgLMhcubGl2ZTE3OC52MS5Vc2VyUHJvZmlsZSJBChRVcGRhdGVQcm9maWxlUmVxdWVzdBIQCghuaWNrbmFtZRgBIAEoCRIXCg9hdmF0YXJfYXNzZXRfaWQYAiABKAkiQQoVVXBkYXRlUHJvZmlsZVJlc3BvbnNlEigKB3Byb2ZpbGUYASABKAsyFy5saXZlMTc4LnYxLlVzZXJQcm9maWxlIjwKE0xpc3RTZXNzaW9uc1JlcXVlc3QSJQoEcGFnZRgBIAEoCzIXLmxpdmUxNzgudjEuUGFnZVJlcXVlc3QiawoUTGlzdFNlc3Npb25zUmVzcG9uc2USKwoIc2Vzc2lvbnMYASADKAsyGS5saXZlMTc4LnYxLkRldmljZVNlc3Npb24SJgoEcGFnZRgCIAEoCzIYLmxpdmUxNzgudjEuUGFnZVJlc3BvbnNlIioKFFJldm9rZVNlc3Npb25SZXF1ZXN0EhIKCnNlc3Npb25faWQYASABKAkiRAoVUmV2b2tlU2Vzc2lvblJlc3BvbnNlEisKBnJlc3VsdBgBIAEoCzIbLmxpdmUxNzgudjEuT3BlcmF0aW9uUmVzdWx0IrYBChBTdWJtaXRLeWNSZXF1ZXN0EhEKCXJlYWxfbmFtZRgBIAEoCRIWCg5pZF9jYXJkX251bWJlchgCIAEoCRIeChZpZF9jYXJkX2Zyb250X2Fzc2V0X2lkGAMgASgJEh0KFWlkX2NhcmRfYmFja19hc3NldF9pZBgEIAEoCRIfChdmYWNlX3ZlcmlmaWNhdGlvbl90b2tlbhgFIAEoCRIXCg9jb25zZW50X3ZlcnNpb24YBiABKAkihQEKEVN1Ym1pdEt5Y1Jlc3BvbnNlEhcKD3ZlcmlmaWNhdGlvbl9pZBgBIAEoCRIlCgZzdGF0dXMYAiABKA4yFS5saXZlMTc4LnYxLkt5Y1N0YXR1cxIwCgxzdWJtaXR0ZWRfYXQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIhUKE0dldEt5Y1N0YXR1c1JlcXVlc3Qi0gEKFEdldEt5Y1N0YXR1c1Jlc3BvbnNlEhcKD3ZlcmlmaWNhdGlvbl9pZBgBIAEoCRIlCgZzdGF0dXMYAiABKA4yFS5saXZlMTc4LnYxLkt5Y1N0YXR1cxIYChByZWFsX25hbWVfbWFza2VkGAMgASgJEhYKDmlkX2NhcmRfbWFza2VkGAQgASgJEhgKEHJlamVjdGlvbl9yZWFzb24YBSABKAkSLgoKdXBkYXRlZF9hdBgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiYwoSU2V0VGVlbk1vZGVSZXF1ZXN0Eg8KB2VuYWJsZWQYASABKAgSGQoRZ3VhcmRpYW5fcGFzc3dvcmQYAiABKAkSIQoZY3VycmVudF9ndWFyZGlhbl9wYXNzd29yZBgDIAEoCSLWAQoOVGVlbk1vZGVQb2xpY3kSDwoHZW5hYmxlZBgBIAEoCBIgChhibG9ja2VkX3N0YXJ0X2xvY2FsX3RpbWUYAiABKAkSHgoWYmxvY2tlZF9lbmRfbG9jYWxfdGltZRgDIAEoCRIbChNkYWlseV9saW1pdF9taW51dGVzGAQgASgFEhoKEnVzZWRfdG9kYXlfbWludXRlcxgFIAEoBRIZChFwYXltZW50c19kaXNhYmxlZBgGIAEoCBIdChVtYXR1cmVfY29udGVudF9oaWRkZW4YByABKAgiQQoTU2V0VGVlbk1vZGVSZXNwb25zZRIqCgZwb2xpY3kYASABKAsyGi5saXZlMTc4LnYxLlRlZW5Nb2RlUG9saWN5IhQKEkdldFRlZW5Nb2RlUmVxdWVzdCJBChNHZXRUZWVuTW9kZVJlc3BvbnNlEioKBnBvbGljeRgBIAEoCzIaLmxpdmUxNzgudjEuVGVlbk1vZGVQb2xpY3kiRwoVQ2hhbmdlUGFzc3dvcmRSZXF1ZXN0EhgKEGN1cnJlbnRfcGFzc3dvcmQYASABKAkSFAoMbmV3X3Bhc3N3b3JkGAIgASgJIkUKFkNoYW5nZVBhc3N3b3JkUmVzcG9uc2USKwoGcmVzdWx0GAEgASgLMhsubGl2ZTE3OC52MS5PcGVyYXRpb25SZXN1bHQiYgoUUmVzZXRQYXNzd29yZFJlcXVlc3QSFAoMY2hhbGxlbmdlX2lkGAEgASgJEgsKA290cBgCIAEoCRIRCglkZXZpY2VfaWQYAyABKAkSFAoMbmV3X3Bhc3N3b3JkGAQgASgJIkQKFVJlc2V0UGFzc3dvcmRSZXNwb25zZRIrCgZyZXN1bHQYASABKAsyGy5saXZlMTc4LnYxLk9wZXJhdGlvblJlc3VsdCJJCh1SZXF1ZXN0QWNjb3VudERlbGV0aW9uUmVxdWVzdBIYChBjdXJyZW50X3Bhc3N3b3JkGAEgASgJEg4KBnJlYXNvbhgCIAEoCSJwCh5SZXF1ZXN0QWNjb3VudERlbGV0aW9uUmVzcG9uc2USGwoTZGVsZXRpb25fcmVxdWVzdF9pZBgBIAEoCRIxCg1zY2hlZHVsZWRfZm9yGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCJUChxDYW5jZWxBY2NvdW50RGVsZXRpb25SZXF1ZXN0EhQKDGNoYWxsZW5nZV9pZBgBIAEoCRILCgNvdHAYAiABKAkSEQoJZGV2aWNlX2lkGAMgASgJIkwKHUNhbmNlbEFjY291bnREZWxldGlvblJlc3BvbnNlEisKBnJlc3VsdBgBIAEoCzIbLmxpdmUxNzgudjEuT3BlcmF0aW9uUmVzdWx0Iu4BChJQZXJzb25hbERhdGFFeHBvcnQSEQoJZXhwb3J0X2lkGAEgASgJEg4KBnN0YXR1cxgCIAEoCRIOCgZmb3JtYXQYAyABKAkSMAoMcmVxdWVzdGVkX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIwCgxjb21wbGV0ZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCmV4cGlyZXNfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhEKCWRhdGFfanNvbhgHIAEoCSIqChhSZXF1ZXN0RGF0YUV4cG9ydFJlcXVlc3QSDgoGZm9ybWF0GAEgASgJIksKGVJlcXVlc3REYXRhRXhwb3J0UmVzcG9uc2USLgoGZXhwb3J0GAEgASgLMh4ubGl2ZTE3OC52MS5QZXJzb25hbERhdGFFeHBvcnQiKQoUR2V0RGF0YUV4cG9ydFJlcXVlc3QSEQoJZXhwb3J0X2lkGAEgASgJIkcKFUdldERhdGFFeHBvcnRSZXNwb25zZRIuCgZleHBvcnQYASABKAsyHi5saXZlMTc4LnYxLlBlcnNvbmFsRGF0YUV4cG9ydCJ/CgtVc2VyQ29uc2VudBIUCgxjb25zZW50X3R5cGUYASABKAkSGAoQZG9jdW1lbnRfdmVyc2lvbhgCIAEoCRIPCgdncmFudGVkGAMgASgIEi8KC3JlY29yZGVkX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCJXChRSZWNvcmRDb25zZW50UmVxdWVzdBIUCgxjb25zZW50X3R5cGUYASABKAkSGAoQZG9jdW1lbnRfdmVyc2lvbhgCIAEoCRIPCgdncmFudGVkGAMgASgIIkEKFVJlY29yZENvbnNlbnRSZXNwb25zZRIoCgdjb25zZW50GAEgASgLMhcubGl2ZTE3OC52MS5Vc2VyQ29uc2VudCI8ChNMaXN0Q29uc2VudHNSZXF1ZXN0EiUKBHBhZ2UYASABKAsyFy5saXZlMTc4LnYxLlBhZ2VSZXF1ZXN0ImkKFExpc3RDb25zZW50c1Jlc3BvbnNlEikKCGNvbnNlbnRzGAEgAygLMhcubGl2ZTE3OC52MS5Vc2VyQ29uc2VudBImCgRwYWdlGAIgASgLMhgubGl2ZTE3OC52MS5QYWdlUmVzcG9uc2UqlQEKClVzZXJTdGF0dXMSGwoXVVNFUl9TVEFUVVNfVU5TUEVDSUZJRUQQABIWChJVU0VSX1NUQVRVU19BQ1RJVkUQARIWChJVU0VSX1NUQVRVU19MT0NLRUQQAhIYChRVU0VSX1NUQVRVU19ESVNBQkxFRBADEiAKHFVTRVJfU1RBVFVTX0RFTEVUSU9OX1BFTkRJTkcQBCpUCglVc2VyTGV2ZWwSGgoWVVNFUl9MRVZFTF9VTlNQRUNJRklFRBAAEhUKEVVTRVJfTEVWRUxfTk9STUFMEAESFAoQVVNFUl9MRVZFTF9TVVBFUhACKqcBCglLeWNTdGF0dXMSGgoWS1lDX1NUQVRVU19VTlNQRUNJRklFRBAAEhwKGEtZQ19TVEFUVVNfTk9UX1NVQk1JVFRFRBABEhYKEktZQ19TVEFUVVNfUEVORElORxACEhcKE0tZQ19TVEFUVVNfQVBQUk9WRUQQAxIXChNLWUNfU1RBVFVTX1JFSkVDVEVEEAQSFgoSS1lDX1NUQVRVU19FWFBJUkVEEAUy1w4KD0lkZW50aXR5U2VydmljZRJLCgpSZXF1ZXN0T3RwEh0ubGl2ZTE3OC52MS5SZXF1ZXN0T3RwUmVxdWVzdBoeLmxpdmUxNzgudjEuUmVxdWVzdE90cFJlc3BvbnNlEkgKCVZlcmlmeU90cBIcLmxpdmUxNzgudjEuVmVyaWZ5T3RwUmVxdWVzdBodLmxpdmUxNzgudjEuVmVyaWZ5T3RwUmVzcG9uc2USRQoIUmVnaXN0ZXISGy5saXZlMTc4LnYxLlJlZ2lzdGVyUmVxdWVzdBocLmxpdmUxNzgudjEuUmVnaXN0ZXJSZXNwb25zZRJUCg1QYXNzd29yZExvZ2luEiAubGl2ZTE3OC52MS5QYXNzd29yZExvZ2luUmVxdWVzdBohLmxpdmUxNzgudjEuUGFzc3dvcmRMb2dpblJlc3BvbnNlElcKDlJlZnJlc2hTZXNzaW9uEiEubGl2ZTE3OC52MS5SZWZyZXNoU2Vzc2lvblJlcXVlc3QaIi5saXZlMTc4LnYxLlJlZnJlc2hTZXNzaW9uUmVzcG9uc2USPwoGTG9nb3V0EhkubGl2ZTE3OC52MS5Mb2dvdXRSZXF1ZXN0GhoubGl2ZTE3OC52MS5Mb2dvdXRSZXNwb25zZRJLCgpHZXRQcm9maWxlEh0ubGl2ZTE3OC52MS5HZXRQcm9maWxlUmVxdWVzdBoeLmxpdmUxNzgudjEuR2V0UHJvZmlsZVJlc3BvbnNlElQKDVVwZGF0ZVByb2ZpbGUSIC5saXZlMTc4LnYxLlVwZGF0ZVByb2ZpbGVSZXF1ZXN0GiEubGl2ZTE3OC52MS5VcGRhdGVQcm9maWxlUmVzcG9uc2USUQoMTGlzdFNlc3Npb25zEh8ubGl2ZTE3OC52MS5MaXN0U2Vzc2lvbnNSZXF1ZXN0GiAubGl2ZTE3OC52MS5MaXN0U2Vzc2lvbnNSZXNwb25zZRJUCg1SZXZva2VTZXNzaW9uEiAubGl2ZTE3OC52MS5SZXZva2VTZXNzaW9uUmVxdWVzdBohLmxpdmUxNzgudjEuUmV2b2tlU2Vzc2lvblJlc3BvbnNlEkgKCVN1Ym1pdEt5YxIcLmxpdmUxNzgudjEuU3VibWl0S3ljUmVxdWVzdBodLmxpdmUxNzgudjEuU3VibWl0S3ljUmVzcG9uc2USUQoMR2V0S3ljU3RhdHVzEh8ubGl2ZTE3OC52MS5HZXRLeWNTdGF0dXNSZXF1ZXN0GiAubGl2ZTE3OC52MS5HZXRLeWNTdGF0dXNSZXNwb25zZRJOCgtTZXRUZWVuTW9kZRIeLmxpdmUxNzgudjEuU2V0VGVlbk1vZGVSZXF1ZXN0Gh8ubGl2ZTE3OC52MS5TZXRUZWVuTW9kZVJlc3BvbnNlEk4KC0dldFRlZW5Nb2RlEh4ubGl2ZTE3OC52MS5HZXRUZWVuTW9kZVJlcXVlc3QaHy5saXZlMTc4LnYxLkdldFRlZW5Nb2RlUmVzcG9uc2USVwoOQ2hhbmdlUGFzc3dvcmQSIS5saXZlMTc4LnYxLkNoYW5nZVBhc3N3b3JkUmVxdWVzdBoiLmxpdmUxNzgudjEuQ2hhbmdlUGFzc3dvcmRSZXNwb25zZRJUCg1SZXNldFBhc3N3b3JkEiAubGl2ZTE3OC52MS5SZXNldFBhc3N3b3JkUmVxdWVzdBohLmxpdmUxNzgudjEuUmVzZXRQYXNzd29yZFJlc3BvbnNlEm8KFlJlcXVlc3RBY2NvdW50RGVsZXRpb24SKS5saXZlMTc4LnYxLlJlcXVlc3RBY2NvdW50RGVsZXRpb25SZXF1ZXN0GioubGl2ZTE3OC52MS5SZXF1ZXN0QWNjb3VudERlbGV0aW9uUmVzcG9uc2USbAoVQ2FuY2VsQWNjb3VudERlbGV0aW9uEigubGl2ZTE3OC52MS5DYW5jZWxBY2NvdW50RGVsZXRpb25SZXF1ZXN0GikubGl2ZTE3OC52MS5DYW5jZWxBY2NvdW50RGVsZXRpb25SZXNwb25zZRJgChFSZXF1ZXN0RGF0YUV4cG9ydBIkLmxpdmUxNzgudjEuUmVxdWVzdERhdGFFeHBvcnRSZXF1ZXN0GiUubGl2ZTE3OC52MS5SZXF1ZXN0RGF0YUV4cG9ydFJlc3BvbnNlElQKDUdldERhdGFFeHBvcnQSIC5saXZlMTc4LnYxLkdldERhdGFFeHBvcnRSZXF1ZXN0GiEubGl2ZTE3OC52MS5HZXREYXRhRXhwb3J0UmVzcG9uc2USVAoNUmVjb3JkQ29uc2VudBIgLmxpdmUxNzgudjEuUmVjb3JkQ29uc2VudFJlcXVlc3QaIS5saXZlMTc4LnYxLlJlY29yZENvbnNlbnRSZXNwb25zZRJRCgxMaXN0Q29uc2VudHMSHy5saXZlMTc4LnYxLkxpc3RDb25zZW50c1JlcXVlc3QaIC5saXZlMTc4LnYxLkxpc3RDb25zZW50c1Jlc3BvbnNlQjlaN2dpdGh1Yi5jb20vbGl2ZTE3OC9wbGF0Zm9ybS9nZW4vZ28vbGl2ZTE3OC92MTtsaXZlMTc4djFiBnByb3RvMw", [file_google_protobuf_timestamp, file_live178_v1_common]);

/**
 * @generated from message live178.v1.UserProfile
 */
export type UserProfile = Message<"live178.v1.UserProfile"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string phone_masked = 2;
   */
  phoneMasked: string;

  /**
   * @generated from field: string nickname = 3;
   */
  nickname: string;

  /**
   * @generated from field: string avatar_url = 4;
   */
  avatarUrl: string;

  /**
   * @generated from field: live178.v1.UserStatus status = 5;
   */
  status: UserStatus;

  /**
   * @generated from field: live178.v1.KycStatus kyc_status = 6;
   */
  kycStatus: KycStatus;

  /**
   * @generated from field: bool teen_mode = 7;
   */
  teenMode: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: live178.v1.UserLevel user_level = 9;
   */
  userLevel: UserLevel;
};

/**
 * Describes the message live178.v1.UserProfile.
 * Use `create(UserProfileSchema)` to create a new message.
 */
export const UserProfileSchema: GenMessage<UserProfile> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 0);

/**
 * @generated from message live178.v1.DeviceSession
 */
export type DeviceSession = Message<"live178.v1.DeviceSession"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string device_id = 2;
   */
  deviceId: string;

  /**
   * @generated from field: string platform = 3;
   */
  platform: string;

  /**
   * @generated from field: string device_name = 4;
   */
  deviceName: string;

  /**
   * @generated from field: string last_ip_masked = 5;
   */
  lastIpMasked: string;

  /**
   * @generated from field: google.protobuf.Timestamp last_seen_at = 6;
   */
  lastSeenAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 7;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * @generated from field: bool current = 8;
   */
  current: boolean;
};

/**
 * Describes the message live178.v1.DeviceSession.
 * Use `create(DeviceSessionSchema)` to create a new message.
 */
export const DeviceSessionSchema: GenMessage<DeviceSession> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 1);

/**
 * @generated from message live178.v1.RequestOtpRequest
 */
export type RequestOtpRequest = Message<"live178.v1.RequestOtpRequest"> & {
  /**
   * @generated from field: string phone_e164 = 1;
   */
  phoneE164: string;

  /**
   * @generated from field: string purpose = 2;
   */
  purpose: string;

  /**
   * @generated from field: string captcha_token = 3;
   */
  captchaToken: string;

  /**
   * @generated from field: string device_id = 4;
   */
  deviceId: string;
};

/**
 * Describes the message live178.v1.RequestOtpRequest.
 * Use `create(RequestOtpRequestSchema)` to create a new message.
 */
export const RequestOtpRequestSchema: GenMessage<RequestOtpRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 2);

/**
 * @generated from message live178.v1.RequestOtpResponse
 */
export type RequestOtpResponse = Message<"live178.v1.RequestOtpResponse"> & {
  /**
   * @generated from field: string challenge_id = 1;
   */
  challengeId: string;

  /**
   * @generated from field: int32 retry_after_seconds = 2;
   */
  retryAfterSeconds: number;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * @generated from field: string debug_otp = 4;
   */
  debugOtp: string;
};

/**
 * Describes the message live178.v1.RequestOtpResponse.
 * Use `create(RequestOtpResponseSchema)` to create a new message.
 */
export const RequestOtpResponseSchema: GenMessage<RequestOtpResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 3);

/**
 * @generated from message live178.v1.VerifyOtpRequest
 */
export type VerifyOtpRequest = Message<"live178.v1.VerifyOtpRequest"> & {
  /**
   * @generated from field: string challenge_id = 1;
   */
  challengeId: string;

  /**
   * @generated from field: string otp = 2;
   */
  otp: string;

  /**
   * @generated from field: string device_id = 3;
   */
  deviceId: string;

  /**
   * @generated from field: string device_name = 4;
   */
  deviceName: string;

  /**
   * @generated from field: string platform = 5;
   */
  platform: string;
};

/**
 * Describes the message live178.v1.VerifyOtpRequest.
 * Use `create(VerifyOtpRequestSchema)` to create a new message.
 */
export const VerifyOtpRequestSchema: GenMessage<VerifyOtpRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 4);

/**
 * @generated from message live178.v1.VerifyOtpResponse
 */
export type VerifyOtpResponse = Message<"live178.v1.VerifyOtpResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;

  /**
   * @generated from field: google.protobuf.Timestamp access_expires_at = 3;
   */
  accessExpiresAt?: Timestamp | undefined;

  /**
   * @generated from field: live178.v1.UserProfile profile = 4;
   */
  profile?: UserProfile | undefined;
};

/**
 * Describes the message live178.v1.VerifyOtpResponse.
 * Use `create(VerifyOtpResponseSchema)` to create a new message.
 */
export const VerifyOtpResponseSchema: GenMessage<VerifyOtpResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 5);

/**
 * @generated from message live178.v1.RegisterRequest
 */
export type RegisterRequest = Message<"live178.v1.RegisterRequest"> & {
  /**
   * @generated from field: string challenge_id = 1;
   */
  challengeId: string;

  /**
   * @generated from field: string otp = 2;
   */
  otp: string;

  /**
   * @generated from field: string password = 3;
   */
  password: string;

  /**
   * @generated from field: string nickname = 4;
   */
  nickname: string;

  /**
   * @generated from field: string device_id = 5;
   */
  deviceId: string;

  /**
   * @generated from field: string device_name = 6;
   */
  deviceName: string;

  /**
   * @generated from field: string platform = 7;
   */
  platform: string;

  /**
   * @generated from field: string terms_document_version = 8;
   */
  termsDocumentVersion: string;

  /**
   * @generated from field: string privacy_document_version = 9;
   */
  privacyDocumentVersion: string;

  /**
   * @generated from field: bool consent_granted = 10;
   */
  consentGranted: boolean;
};

/**
 * Describes the message live178.v1.RegisterRequest.
 * Use `create(RegisterRequestSchema)` to create a new message.
 */
export const RegisterRequestSchema: GenMessage<RegisterRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 6);

/**
 * @generated from message live178.v1.RegisterResponse
 */
export type RegisterResponse = Message<"live178.v1.RegisterResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;

  /**
   * @generated from field: google.protobuf.Timestamp access_expires_at = 3;
   */
  accessExpiresAt?: Timestamp | undefined;

  /**
   * @generated from field: live178.v1.UserProfile profile = 4;
   */
  profile?: UserProfile | undefined;
};

/**
 * Describes the message live178.v1.RegisterResponse.
 * Use `create(RegisterResponseSchema)` to create a new message.
 */
export const RegisterResponseSchema: GenMessage<RegisterResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 7);

/**
 * @generated from message live178.v1.PasswordLoginRequest
 */
export type PasswordLoginRequest = Message<"live178.v1.PasswordLoginRequest"> & {
  /**
   * @generated from field: string account = 1;
   */
  account: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: string device_id = 3;
   */
  deviceId: string;

  /**
   * @generated from field: string device_name = 4;
   */
  deviceName: string;

  /**
   * @generated from field: string platform = 5;
   */
  platform: string;
};

/**
 * Describes the message live178.v1.PasswordLoginRequest.
 * Use `create(PasswordLoginRequestSchema)` to create a new message.
 */
export const PasswordLoginRequestSchema: GenMessage<PasswordLoginRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 8);

/**
 * @generated from message live178.v1.PasswordLoginResponse
 */
export type PasswordLoginResponse = Message<"live178.v1.PasswordLoginResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;

  /**
   * @generated from field: google.protobuf.Timestamp access_expires_at = 3;
   */
  accessExpiresAt?: Timestamp | undefined;

  /**
   * @generated from field: live178.v1.UserProfile profile = 4;
   */
  profile?: UserProfile | undefined;
};

/**
 * Describes the message live178.v1.PasswordLoginResponse.
 * Use `create(PasswordLoginResponseSchema)` to create a new message.
 */
export const PasswordLoginResponseSchema: GenMessage<PasswordLoginResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 9);

/**
 * @generated from message live178.v1.RefreshSessionRequest
 */
export type RefreshSessionRequest = Message<"live178.v1.RefreshSessionRequest"> & {
  /**
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;

  /**
   * @generated from field: string device_id = 2;
   */
  deviceId: string;
};

/**
 * Describes the message live178.v1.RefreshSessionRequest.
 * Use `create(RefreshSessionRequestSchema)` to create a new message.
 */
export const RefreshSessionRequestSchema: GenMessage<RefreshSessionRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 10);

/**
 * @generated from message live178.v1.RefreshSessionResponse
 */
export type RefreshSessionResponse = Message<"live178.v1.RefreshSessionResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken: string;

  /**
   * @generated from field: google.protobuf.Timestamp access_expires_at = 3;
   */
  accessExpiresAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.RefreshSessionResponse.
 * Use `create(RefreshSessionResponseSchema)` to create a new message.
 */
export const RefreshSessionResponseSchema: GenMessage<RefreshSessionResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 11);

/**
 * @generated from message live178.v1.LogoutRequest
 */
export type LogoutRequest = Message<"live178.v1.LogoutRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: bool all_devices = 2;
   */
  allDevices: boolean;
};

/**
 * Describes the message live178.v1.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 12);

/**
 * @generated from message live178.v1.LogoutResponse
 */
export type LogoutResponse = Message<"live178.v1.LogoutResponse"> & {
  /**
   * @generated from field: int32 revoked_sessions = 1;
   */
  revokedSessions: number;
};

/**
 * Describes the message live178.v1.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 13);

/**
 * @generated from message live178.v1.GetProfileRequest
 */
export type GetProfileRequest = Message<"live178.v1.GetProfileRequest"> & {
};

/**
 * Describes the message live178.v1.GetProfileRequest.
 * Use `create(GetProfileRequestSchema)` to create a new message.
 */
export const GetProfileRequestSchema: GenMessage<GetProfileRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 14);

/**
 * @generated from message live178.v1.GetProfileResponse
 */
export type GetProfileResponse = Message<"live178.v1.GetProfileResponse"> & {
  /**
   * @generated from field: live178.v1.UserProfile profile = 1;
   */
  profile?: UserProfile | undefined;
};

/**
 * Describes the message live178.v1.GetProfileResponse.
 * Use `create(GetProfileResponseSchema)` to create a new message.
 */
export const GetProfileResponseSchema: GenMessage<GetProfileResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 15);

/**
 * @generated from message live178.v1.UpdateProfileRequest
 */
export type UpdateProfileRequest = Message<"live178.v1.UpdateProfileRequest"> & {
  /**
   * @generated from field: string nickname = 1;
   */
  nickname: string;

  /**
   * @generated from field: string avatar_asset_id = 2;
   */
  avatarAssetId: string;
};

/**
 * Describes the message live178.v1.UpdateProfileRequest.
 * Use `create(UpdateProfileRequestSchema)` to create a new message.
 */
export const UpdateProfileRequestSchema: GenMessage<UpdateProfileRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 16);

/**
 * @generated from message live178.v1.UpdateProfileResponse
 */
export type UpdateProfileResponse = Message<"live178.v1.UpdateProfileResponse"> & {
  /**
   * @generated from field: live178.v1.UserProfile profile = 1;
   */
  profile?: UserProfile | undefined;
};

/**
 * Describes the message live178.v1.UpdateProfileResponse.
 * Use `create(UpdateProfileResponseSchema)` to create a new message.
 */
export const UpdateProfileResponseSchema: GenMessage<UpdateProfileResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 17);

/**
 * @generated from message live178.v1.ListSessionsRequest
 */
export type ListSessionsRequest = Message<"live178.v1.ListSessionsRequest"> & {
  /**
   * @generated from field: live178.v1.PageRequest page = 1;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListSessionsRequest.
 * Use `create(ListSessionsRequestSchema)` to create a new message.
 */
export const ListSessionsRequestSchema: GenMessage<ListSessionsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 18);

/**
 * @generated from message live178.v1.ListSessionsResponse
 */
export type ListSessionsResponse = Message<"live178.v1.ListSessionsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.DeviceSession sessions = 1;
   */
  sessions: DeviceSession[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListSessionsResponse.
 * Use `create(ListSessionsResponseSchema)` to create a new message.
 */
export const ListSessionsResponseSchema: GenMessage<ListSessionsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 19);

/**
 * @generated from message live178.v1.RevokeSessionRequest
 */
export type RevokeSessionRequest = Message<"live178.v1.RevokeSessionRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message live178.v1.RevokeSessionRequest.
 * Use `create(RevokeSessionRequestSchema)` to create a new message.
 */
export const RevokeSessionRequestSchema: GenMessage<RevokeSessionRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 20);

/**
 * @generated from message live178.v1.RevokeSessionResponse
 */
export type RevokeSessionResponse = Message<"live178.v1.RevokeSessionResponse"> & {
  /**
   * @generated from field: live178.v1.OperationResult result = 1;
   */
  result?: OperationResult | undefined;
};

/**
 * Describes the message live178.v1.RevokeSessionResponse.
 * Use `create(RevokeSessionResponseSchema)` to create a new message.
 */
export const RevokeSessionResponseSchema: GenMessage<RevokeSessionResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 21);

/**
 * @generated from message live178.v1.SubmitKycRequest
 */
export type SubmitKycRequest = Message<"live178.v1.SubmitKycRequest"> & {
  /**
   * @generated from field: string real_name = 1;
   */
  realName: string;

  /**
   * @generated from field: string id_card_number = 2;
   */
  idCardNumber: string;

  /**
   * @generated from field: string id_card_front_asset_id = 3;
   */
  idCardFrontAssetId: string;

  /**
   * @generated from field: string id_card_back_asset_id = 4;
   */
  idCardBackAssetId: string;

  /**
   * @generated from field: string face_verification_token = 5;
   */
  faceVerificationToken: string;

  /**
   * @generated from field: string consent_version = 6;
   */
  consentVersion: string;
};

/**
 * Describes the message live178.v1.SubmitKycRequest.
 * Use `create(SubmitKycRequestSchema)` to create a new message.
 */
export const SubmitKycRequestSchema: GenMessage<SubmitKycRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 22);

/**
 * @generated from message live178.v1.SubmitKycResponse
 */
export type SubmitKycResponse = Message<"live178.v1.SubmitKycResponse"> & {
  /**
   * @generated from field: string verification_id = 1;
   */
  verificationId: string;

  /**
   * @generated from field: live178.v1.KycStatus status = 2;
   */
  status: KycStatus;

  /**
   * @generated from field: google.protobuf.Timestamp submitted_at = 3;
   */
  submittedAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.SubmitKycResponse.
 * Use `create(SubmitKycResponseSchema)` to create a new message.
 */
export const SubmitKycResponseSchema: GenMessage<SubmitKycResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 23);

/**
 * @generated from message live178.v1.GetKycStatusRequest
 */
export type GetKycStatusRequest = Message<"live178.v1.GetKycStatusRequest"> & {
};

/**
 * Describes the message live178.v1.GetKycStatusRequest.
 * Use `create(GetKycStatusRequestSchema)` to create a new message.
 */
export const GetKycStatusRequestSchema: GenMessage<GetKycStatusRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 24);

/**
 * @generated from message live178.v1.GetKycStatusResponse
 */
export type GetKycStatusResponse = Message<"live178.v1.GetKycStatusResponse"> & {
  /**
   * @generated from field: string verification_id = 1;
   */
  verificationId: string;

  /**
   * @generated from field: live178.v1.KycStatus status = 2;
   */
  status: KycStatus;

  /**
   * @generated from field: string real_name_masked = 3;
   */
  realNameMasked: string;

  /**
   * @generated from field: string id_card_masked = 4;
   */
  idCardMasked: string;

  /**
   * @generated from field: string rejection_reason = 5;
   */
  rejectionReason: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.GetKycStatusResponse.
 * Use `create(GetKycStatusResponseSchema)` to create a new message.
 */
export const GetKycStatusResponseSchema: GenMessage<GetKycStatusResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 25);

/**
 * @generated from message live178.v1.SetTeenModeRequest
 */
export type SetTeenModeRequest = Message<"live178.v1.SetTeenModeRequest"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: string guardian_password = 2;
   */
  guardianPassword: string;

  /**
   * @generated from field: string current_guardian_password = 3;
   */
  currentGuardianPassword: string;
};

/**
 * Describes the message live178.v1.SetTeenModeRequest.
 * Use `create(SetTeenModeRequestSchema)` to create a new message.
 */
export const SetTeenModeRequestSchema: GenMessage<SetTeenModeRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 26);

/**
 * @generated from message live178.v1.TeenModePolicy
 */
export type TeenModePolicy = Message<"live178.v1.TeenModePolicy"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: string blocked_start_local_time = 2;
   */
  blockedStartLocalTime: string;

  /**
   * @generated from field: string blocked_end_local_time = 3;
   */
  blockedEndLocalTime: string;

  /**
   * @generated from field: int32 daily_limit_minutes = 4;
   */
  dailyLimitMinutes: number;

  /**
   * @generated from field: int32 used_today_minutes = 5;
   */
  usedTodayMinutes: number;

  /**
   * @generated from field: bool payments_disabled = 6;
   */
  paymentsDisabled: boolean;

  /**
   * @generated from field: bool mature_content_hidden = 7;
   */
  matureContentHidden: boolean;
};

/**
 * Describes the message live178.v1.TeenModePolicy.
 * Use `create(TeenModePolicySchema)` to create a new message.
 */
export const TeenModePolicySchema: GenMessage<TeenModePolicy> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 27);

/**
 * @generated from message live178.v1.SetTeenModeResponse
 */
export type SetTeenModeResponse = Message<"live178.v1.SetTeenModeResponse"> & {
  /**
   * @generated from field: live178.v1.TeenModePolicy policy = 1;
   */
  policy?: TeenModePolicy | undefined;
};

/**
 * Describes the message live178.v1.SetTeenModeResponse.
 * Use `create(SetTeenModeResponseSchema)` to create a new message.
 */
export const SetTeenModeResponseSchema: GenMessage<SetTeenModeResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 28);

/**
 * @generated from message live178.v1.GetTeenModeRequest
 */
export type GetTeenModeRequest = Message<"live178.v1.GetTeenModeRequest"> & {
};

/**
 * Describes the message live178.v1.GetTeenModeRequest.
 * Use `create(GetTeenModeRequestSchema)` to create a new message.
 */
export const GetTeenModeRequestSchema: GenMessage<GetTeenModeRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 29);

/**
 * @generated from message live178.v1.GetTeenModeResponse
 */
export type GetTeenModeResponse = Message<"live178.v1.GetTeenModeResponse"> & {
  /**
   * @generated from field: live178.v1.TeenModePolicy policy = 1;
   */
  policy?: TeenModePolicy | undefined;
};

/**
 * Describes the message live178.v1.GetTeenModeResponse.
 * Use `create(GetTeenModeResponseSchema)` to create a new message.
 */
export const GetTeenModeResponseSchema: GenMessage<GetTeenModeResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 30);

/**
 * @generated from message live178.v1.ChangePasswordRequest
 */
export type ChangePasswordRequest = Message<"live178.v1.ChangePasswordRequest"> & {
  /**
   * @generated from field: string current_password = 1;
   */
  currentPassword: string;

  /**
   * @generated from field: string new_password = 2;
   */
  newPassword: string;
};

/**
 * Describes the message live178.v1.ChangePasswordRequest.
 * Use `create(ChangePasswordRequestSchema)` to create a new message.
 */
export const ChangePasswordRequestSchema: GenMessage<ChangePasswordRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 31);

/**
 * @generated from message live178.v1.ChangePasswordResponse
 */
export type ChangePasswordResponse = Message<"live178.v1.ChangePasswordResponse"> & {
  /**
   * @generated from field: live178.v1.OperationResult result = 1;
   */
  result?: OperationResult | undefined;
};

/**
 * Describes the message live178.v1.ChangePasswordResponse.
 * Use `create(ChangePasswordResponseSchema)` to create a new message.
 */
export const ChangePasswordResponseSchema: GenMessage<ChangePasswordResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 32);

/**
 * @generated from message live178.v1.ResetPasswordRequest
 */
export type ResetPasswordRequest = Message<"live178.v1.ResetPasswordRequest"> & {
  /**
   * @generated from field: string challenge_id = 1;
   */
  challengeId: string;

  /**
   * @generated from field: string otp = 2;
   */
  otp: string;

  /**
   * @generated from field: string device_id = 3;
   */
  deviceId: string;

  /**
   * @generated from field: string new_password = 4;
   */
  newPassword: string;
};

/**
 * Describes the message live178.v1.ResetPasswordRequest.
 * Use `create(ResetPasswordRequestSchema)` to create a new message.
 */
export const ResetPasswordRequestSchema: GenMessage<ResetPasswordRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 33);

/**
 * @generated from message live178.v1.ResetPasswordResponse
 */
export type ResetPasswordResponse = Message<"live178.v1.ResetPasswordResponse"> & {
  /**
   * @generated from field: live178.v1.OperationResult result = 1;
   */
  result?: OperationResult | undefined;
};

/**
 * Describes the message live178.v1.ResetPasswordResponse.
 * Use `create(ResetPasswordResponseSchema)` to create a new message.
 */
export const ResetPasswordResponseSchema: GenMessage<ResetPasswordResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 34);

/**
 * @generated from message live178.v1.RequestAccountDeletionRequest
 */
export type RequestAccountDeletionRequest = Message<"live178.v1.RequestAccountDeletionRequest"> & {
  /**
   * @generated from field: string current_password = 1;
   */
  currentPassword: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message live178.v1.RequestAccountDeletionRequest.
 * Use `create(RequestAccountDeletionRequestSchema)` to create a new message.
 */
export const RequestAccountDeletionRequestSchema: GenMessage<RequestAccountDeletionRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 35);

/**
 * @generated from message live178.v1.RequestAccountDeletionResponse
 */
export type RequestAccountDeletionResponse = Message<"live178.v1.RequestAccountDeletionResponse"> & {
  /**
   * @generated from field: string deletion_request_id = 1;
   */
  deletionRequestId: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 2;
   */
  scheduledFor?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.RequestAccountDeletionResponse.
 * Use `create(RequestAccountDeletionResponseSchema)` to create a new message.
 */
export const RequestAccountDeletionResponseSchema: GenMessage<RequestAccountDeletionResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 36);

/**
 * @generated from message live178.v1.CancelAccountDeletionRequest
 */
export type CancelAccountDeletionRequest = Message<"live178.v1.CancelAccountDeletionRequest"> & {
  /**
   * @generated from field: string challenge_id = 1;
   */
  challengeId: string;

  /**
   * @generated from field: string otp = 2;
   */
  otp: string;

  /**
   * @generated from field: string device_id = 3;
   */
  deviceId: string;
};

/**
 * Describes the message live178.v1.CancelAccountDeletionRequest.
 * Use `create(CancelAccountDeletionRequestSchema)` to create a new message.
 */
export const CancelAccountDeletionRequestSchema: GenMessage<CancelAccountDeletionRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 37);

/**
 * @generated from message live178.v1.CancelAccountDeletionResponse
 */
export type CancelAccountDeletionResponse = Message<"live178.v1.CancelAccountDeletionResponse"> & {
  /**
   * @generated from field: live178.v1.OperationResult result = 1;
   */
  result?: OperationResult | undefined;
};

/**
 * Describes the message live178.v1.CancelAccountDeletionResponse.
 * Use `create(CancelAccountDeletionResponseSchema)` to create a new message.
 */
export const CancelAccountDeletionResponseSchema: GenMessage<CancelAccountDeletionResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 38);

/**
 * @generated from message live178.v1.PersonalDataExport
 */
export type PersonalDataExport = Message<"live178.v1.PersonalDataExport"> & {
  /**
   * @generated from field: string export_id = 1;
   */
  exportId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string format = 3;
   */
  format: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 4;
   */
  requestedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp completed_at = 5;
   */
  completedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 6;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * @generated from field: string data_json = 7;
   */
  dataJson: string;
};

/**
 * Describes the message live178.v1.PersonalDataExport.
 * Use `create(PersonalDataExportSchema)` to create a new message.
 */
export const PersonalDataExportSchema: GenMessage<PersonalDataExport> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 39);

/**
 * @generated from message live178.v1.RequestDataExportRequest
 */
export type RequestDataExportRequest = Message<"live178.v1.RequestDataExportRequest"> & {
  /**
   * @generated from field: string format = 1;
   */
  format: string;
};

/**
 * Describes the message live178.v1.RequestDataExportRequest.
 * Use `create(RequestDataExportRequestSchema)` to create a new message.
 */
export const RequestDataExportRequestSchema: GenMessage<RequestDataExportRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 40);

/**
 * @generated from message live178.v1.RequestDataExportResponse
 */
export type RequestDataExportResponse = Message<"live178.v1.RequestDataExportResponse"> & {
  /**
   * @generated from field: live178.v1.PersonalDataExport export = 1;
   */
  export?: PersonalDataExport | undefined;
};

/**
 * Describes the message live178.v1.RequestDataExportResponse.
 * Use `create(RequestDataExportResponseSchema)` to create a new message.
 */
export const RequestDataExportResponseSchema: GenMessage<RequestDataExportResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 41);

/**
 * @generated from message live178.v1.GetDataExportRequest
 */
export type GetDataExportRequest = Message<"live178.v1.GetDataExportRequest"> & {
  /**
   * @generated from field: string export_id = 1;
   */
  exportId: string;
};

/**
 * Describes the message live178.v1.GetDataExportRequest.
 * Use `create(GetDataExportRequestSchema)` to create a new message.
 */
export const GetDataExportRequestSchema: GenMessage<GetDataExportRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 42);

/**
 * @generated from message live178.v1.GetDataExportResponse
 */
export type GetDataExportResponse = Message<"live178.v1.GetDataExportResponse"> & {
  /**
   * @generated from field: live178.v1.PersonalDataExport export = 1;
   */
  export?: PersonalDataExport | undefined;
};

/**
 * Describes the message live178.v1.GetDataExportResponse.
 * Use `create(GetDataExportResponseSchema)` to create a new message.
 */
export const GetDataExportResponseSchema: GenMessage<GetDataExportResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 43);

/**
 * @generated from message live178.v1.UserConsent
 */
export type UserConsent = Message<"live178.v1.UserConsent"> & {
  /**
   * @generated from field: string consent_type = 1;
   */
  consentType: string;

  /**
   * @generated from field: string document_version = 2;
   */
  documentVersion: string;

  /**
   * @generated from field: bool granted = 3;
   */
  granted: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp recorded_at = 4;
   */
  recordedAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.UserConsent.
 * Use `create(UserConsentSchema)` to create a new message.
 */
export const UserConsentSchema: GenMessage<UserConsent> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 44);

/**
 * @generated from message live178.v1.RecordConsentRequest
 */
export type RecordConsentRequest = Message<"live178.v1.RecordConsentRequest"> & {
  /**
   * @generated from field: string consent_type = 1;
   */
  consentType: string;

  /**
   * @generated from field: string document_version = 2;
   */
  documentVersion: string;

  /**
   * @generated from field: bool granted = 3;
   */
  granted: boolean;
};

/**
 * Describes the message live178.v1.RecordConsentRequest.
 * Use `create(RecordConsentRequestSchema)` to create a new message.
 */
export const RecordConsentRequestSchema: GenMessage<RecordConsentRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 45);

/**
 * @generated from message live178.v1.RecordConsentResponse
 */
export type RecordConsentResponse = Message<"live178.v1.RecordConsentResponse"> & {
  /**
   * @generated from field: live178.v1.UserConsent consent = 1;
   */
  consent?: UserConsent | undefined;
};

/**
 * Describes the message live178.v1.RecordConsentResponse.
 * Use `create(RecordConsentResponseSchema)` to create a new message.
 */
export const RecordConsentResponseSchema: GenMessage<RecordConsentResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 46);

/**
 * @generated from message live178.v1.ListConsentsRequest
 */
export type ListConsentsRequest = Message<"live178.v1.ListConsentsRequest"> & {
  /**
   * @generated from field: live178.v1.PageRequest page = 1;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListConsentsRequest.
 * Use `create(ListConsentsRequestSchema)` to create a new message.
 */
export const ListConsentsRequestSchema: GenMessage<ListConsentsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 47);

/**
 * @generated from message live178.v1.ListConsentsResponse
 */
export type ListConsentsResponse = Message<"live178.v1.ListConsentsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.UserConsent consents = 1;
   */
  consents: UserConsent[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListConsentsResponse.
 * Use `create(ListConsentsResponseSchema)` to create a new message.
 */
export const ListConsentsResponseSchema: GenMessage<ListConsentsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_identity, 48);

/**
 * @generated from enum live178.v1.UserStatus
 */
export enum UserStatus {
  /**
   * @generated from enum value: USER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: USER_STATUS_LOCKED = 2;
   */
  LOCKED = 2,

  /**
   * @generated from enum value: USER_STATUS_DISABLED = 3;
   */
  DISABLED = 3,

  /**
   * @generated from enum value: USER_STATUS_DELETION_PENDING = 4;
   */
  DELETION_PENDING = 4,
}

/**
 * Describes the enum live178.v1.UserStatus.
 */
export const UserStatusSchema: GenEnum<UserStatus> = /*@__PURE__*/
  enumDesc(file_live178_v1_identity, 0);

/**
 * @generated from enum live178.v1.UserLevel
 */
export enum UserLevel {
  /**
   * @generated from enum value: USER_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_LEVEL_NORMAL = 1;
   */
  NORMAL = 1,

  /**
   * @generated from enum value: USER_LEVEL_SUPER = 2;
   */
  SUPER = 2,
}

/**
 * Describes the enum live178.v1.UserLevel.
 */
export const UserLevelSchema: GenEnum<UserLevel> = /*@__PURE__*/
  enumDesc(file_live178_v1_identity, 1);

/**
 * @generated from enum live178.v1.KycStatus
 */
export enum KycStatus {
  /**
   * @generated from enum value: KYC_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: KYC_STATUS_NOT_SUBMITTED = 1;
   */
  NOT_SUBMITTED = 1,

  /**
   * @generated from enum value: KYC_STATUS_PENDING = 2;
   */
  PENDING = 2,

  /**
   * @generated from enum value: KYC_STATUS_APPROVED = 3;
   */
  APPROVED = 3,

  /**
   * @generated from enum value: KYC_STATUS_REJECTED = 4;
   */
  REJECTED = 4,

  /**
   * @generated from enum value: KYC_STATUS_EXPIRED = 5;
   */
  EXPIRED = 5,
}

/**
 * Describes the enum live178.v1.KycStatus.
 */
export const KycStatusSchema: GenEnum<KycStatus> = /*@__PURE__*/
  enumDesc(file_live178_v1_identity, 2);

/**
 * @generated from service live178.v1.IdentityService
 */
export const IdentityService: GenService<{
  /**
   * @generated from rpc live178.v1.IdentityService.RequestOtp
   */
  requestOtp: {
    methodKind: "unary";
    input: typeof RequestOtpRequestSchema;
    output: typeof RequestOtpResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.VerifyOtp
   */
  verifyOtp: {
    methodKind: "unary";
    input: typeof VerifyOtpRequestSchema;
    output: typeof VerifyOtpResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.Register
   */
  register: {
    methodKind: "unary";
    input: typeof RegisterRequestSchema;
    output: typeof RegisterResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.PasswordLogin
   */
  passwordLogin: {
    methodKind: "unary";
    input: typeof PasswordLoginRequestSchema;
    output: typeof PasswordLoginResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.RefreshSession
   */
  refreshSession: {
    methodKind: "unary";
    input: typeof RefreshSessionRequestSchema;
    output: typeof RefreshSessionResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.GetProfile
   */
  getProfile: {
    methodKind: "unary";
    input: typeof GetProfileRequestSchema;
    output: typeof GetProfileResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.UpdateProfile
   */
  updateProfile: {
    methodKind: "unary";
    input: typeof UpdateProfileRequestSchema;
    output: typeof UpdateProfileResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.ListSessions
   */
  listSessions: {
    methodKind: "unary";
    input: typeof ListSessionsRequestSchema;
    output: typeof ListSessionsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.RevokeSession
   */
  revokeSession: {
    methodKind: "unary";
    input: typeof RevokeSessionRequestSchema;
    output: typeof RevokeSessionResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.SubmitKyc
   */
  submitKyc: {
    methodKind: "unary";
    input: typeof SubmitKycRequestSchema;
    output: typeof SubmitKycResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.GetKycStatus
   */
  getKycStatus: {
    methodKind: "unary";
    input: typeof GetKycStatusRequestSchema;
    output: typeof GetKycStatusResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.SetTeenMode
   */
  setTeenMode: {
    methodKind: "unary";
    input: typeof SetTeenModeRequestSchema;
    output: typeof SetTeenModeResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.GetTeenMode
   */
  getTeenMode: {
    methodKind: "unary";
    input: typeof GetTeenModeRequestSchema;
    output: typeof GetTeenModeResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.ChangePassword
   */
  changePassword: {
    methodKind: "unary";
    input: typeof ChangePasswordRequestSchema;
    output: typeof ChangePasswordResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.ResetPassword
   */
  resetPassword: {
    methodKind: "unary";
    input: typeof ResetPasswordRequestSchema;
    output: typeof ResetPasswordResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.RequestAccountDeletion
   */
  requestAccountDeletion: {
    methodKind: "unary";
    input: typeof RequestAccountDeletionRequestSchema;
    output: typeof RequestAccountDeletionResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.CancelAccountDeletion
   */
  cancelAccountDeletion: {
    methodKind: "unary";
    input: typeof CancelAccountDeletionRequestSchema;
    output: typeof CancelAccountDeletionResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.RequestDataExport
   */
  requestDataExport: {
    methodKind: "unary";
    input: typeof RequestDataExportRequestSchema;
    output: typeof RequestDataExportResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.GetDataExport
   */
  getDataExport: {
    methodKind: "unary";
    input: typeof GetDataExportRequestSchema;
    output: typeof GetDataExportResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.RecordConsent
   */
  recordConsent: {
    methodKind: "unary";
    input: typeof RecordConsentRequestSchema;
    output: typeof RecordConsentResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.IdentityService.ListConsents
   */
  listConsents: {
    methodKind: "unary";
    input: typeof ListConsentsRequestSchema;
    output: typeof ListConsentsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_live178_v1_identity, 0);

